import React, { useEffect, useReducer } from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import URL from "../constants/url";

const hasValidStoredAuth = () => {
    try {
        const rawUser = sessionStorage.getItem("loginUser");
        const token = localStorage.getItem("jToken");

        if (!rawUser || !token || !token.trim()) {
            return false;
        }

        const user = JSON.parse(rawUser);

        return Boolean(
            user &&
            typeof user === "object" &&
            !Array.isArray(user) &&
            user.usrUid != null &&
            user.usrUid !== ""
        );
    } catch {
        return false;
    }
};

const ProtectedRoute = () => {
    const location = useLocation();

    // 이벤트 발생 시 최신 저장소 값을 다시 읽도록 렌더링..
    const [, reCheckAuth] = useReducer((count) => count + 1, 0);

    useEffect(() => {
        const handlePageShow = (event) => {
            console.debug("=========> [ProtectedRoute] pageshow :: ", {
                persisted: event.persisted,
                loginUser: sessionStorage.getItem("loginUser"),
                hasToken: Boolean(localStorage.getItem("jToken")),
            });

            reCheckAuth();
        };

        const handleAuthChanged = () => {
            reCheckAuth();
        };

        window.addEventListener("pageshow", handlePageShow);
        window.addEventListener("auth-changed", handleAuthChanged);

        return () => {
            window.removeEventListener("pageshow", handlePageShow);
            window.removeEventListener("auth-changed", handleAuthChanged);
        };
    }, []);

    const isAuthenticated = hasValidStoredAuth();

    /* 원인 확인 후 제거할 진단 로그... 체크완료..
    console.debug("[ProtectedRoute] render", {
        pathname: location.pathname,
        loginUser: sessionStorage.getItem("loginUser"),
        hasToken: Boolean(localStorage.getItem("jToken")),
        isAuthenticated,
    });
    */

    if (!isAuthenticated) {
        return (
            <Navigate
                to={URL.MAIN}
                state={{ from: location }}
                replace
            />
        );
    }

    return <Outlet />;
};

export default ProtectedRoute;
